// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scrollVert {
    overflow: hidden auto;
}

.tabColTree {
    max-height: 65vh;
    overflow: hidden;
}

.treeCheckBox {
    margin: 0px 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/settings/datamodel/dialogs/tabular.column.dialog.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".scrollVert {\n    overflow: hidden auto;\n}\n\n.tabColTree {\n    max-height: 65vh;\n    overflow: hidden;\n}\n\n.treeCheckBox {\n    margin: 0px 5px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
